import React, { useMemo, useState } from 'react';
import { NoData, Skelton, Table } from 'src/@vymo/ui/blocks';
import { getRevyreConfig } from 'src/models/lmsConfig/selectors';
import { REVYRE_WORKFLOW_DETAILS_360 } from 'src/modules/constants';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { renderModule } from 'src/workspace/slice';
import { CASE, TAB_STATUS_KEYS } from '../../constant';
import { getRelatedRecords, getStatus } from '../../selector';
import { fetchActiveCases } from '../../thunk';
import { getCasesColumns } from './queries';

function ActiveCases({ module }: { module: Record<string, any> }) {
  const dispatch = useAppDispatch();
  const activeCases = useAppSelector((state) =>
    getRelatedRecords(state, module.code),
  );
  const { list, meta } = activeCases || {};
  const { totalCount = 0 } = meta || {};

  const revyreConfig = useAppSelector(getRevyreConfig);
  const columns: any = useMemo(
    () => getCasesColumns(revyreConfig),
    [revyreConfig],
  );
  const status = useAppSelector((state) =>
    getStatus(state, TAB_STATUS_KEYS.ACTIVE_CASES),
  );
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [sortBy, setSortBy] = useState<string>('');
  const [sortType, setSortType] = useState<string>('');

  const filters = {
    [module.key || 'lan']: module.entityId,
  };
  return (
    <div>
      {status === 'loading' && <Skelton rounded lines={8} />}
      {status === 'error' && <NoData message="Error fetching entity details" />}
      {status === 'done' && (
        <Table
          isAccordion={false}
          tableData={list}
          columnConfigs={columns}
          tableConfig={{
            showSearch: false,
            hideColumnConfigurator: true,
            isRowSelectionEnabled: false,
            name: '',
            pagination: {
              visible: true,
              pageSize,
              totalPages: Math.max(1, Math.ceil(totalCount / pageSize)),
              currentPage,
              totalItems: totalCount,
            },
            onRowClick: (rowId) => {
              dispatch(
                renderModule({
                  id: REVYRE_WORKFLOW_DETAILS_360,
                  props: {
                    domainType: 'workflow',
                    workflowType: CASE,
                    entityId: rowId,
                  },
                }),
              );
            },
          }}
          onSort={(sortedColumns) => {
            const [sortedColumn] = sortedColumns ?? [];

            if (!sortedColumn) return;

            const { id: columnSortBy, desc } = sortedColumn;
            const columnSortType = desc ? 'desc' : 'asc';
            setSortBy(columnSortBy);
            setSortType(columnSortType);
            dispatch(
              fetchActiveCases({
                payload: {
                  sortBy: columnSortBy,
                  sortType: columnSortType,
                  filters,
                  page: {
                    pageSize,
                    pageNumber: 1,
                  },
                },
              }),
            );
          }}
          onChangePageSize={(updatedPageSize) => {
            setPageSize(updatedPageSize);
            dispatch(
              fetchActiveCases({
                payload: {
                  sortBy,
                  sortType,
                  filters,
                  page: {
                    pageSize: updatedPageSize,
                    pageNumber: 1,
                  },
                },
              }),
            );
          }}
          onChangePageIndex={(pageIndex) => {
            setCurrentPage(Number(pageIndex) + 1);
            dispatch(
              fetchActiveCases({
                payload: {
                  sortBy,
                  sortType,
                  filters,
                  page: {
                    pageSize,
                    pageNumber: Number(pageIndex) + 1,
                  },
                },
              }),
            );
          }}
        />
      )}
    </div>
  );
}

export default ActiveCases;
